// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConfirmationCodeController from "./confirmation_code_controller"
application.register("confirmation-code", ConfirmationCodeController)

import MotifRefusController from "./motif_refus_controller"
application.register("motif-refus", MotifRefusController)

import BanqueAttenteController from "./banque_attente_controller"
application.register("banque-attente", BanqueAttenteController)

import PublicPricingController from "./public_pricing_controller"
application.register("public-pricing", PublicPricingController)

import AccentPickerController from "./accent_picker_controller"
application.register("accent-picker", AccentPickerController)

import AccessToggleController from "./access_toggle_controller"
application.register("access-toggle", AccessToggleController)

import AnalyticsRealtimeController from "./analytics_realtime_controller"
application.register("analytics-realtime", AnalyticsRealtimeController)

import AnalyticsTabsController from "./analytics_tabs_controller"
application.register("analytics-tabs", AnalyticsTabsController)

import ApercuProfilController from "./apercu_profil_controller"
application.register("apercu-profil", ApercuProfilController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BebFlashController from "./beb_flash_controller"
application.register("beb-flash", BebFlashController)

import BebTrackController from "./beb_track_controller"
application.register("beb-track", BebTrackController)

import LandingVideoController from "./landing_video_controller"
application.register("landing-video", LandingVideoController)

import BlockAutosaveController from "./block_autosave_controller"
application.register("block-autosave", BlockAutosaveController)

import BlockSettingsController from "./block_settings_controller"
application.register("block-settings", BlockSettingsController)

import BookCheckoutController from "./book_checkout_controller"
application.register("book-checkout", BookCheckoutController)

import BookCoverPreviewController from "./book_cover_preview_controller"
application.register("book-cover-preview", BookCoverPreviewController)

import BookVariantsController from "./book_variants_controller"
application.register("book-variants", BookVariantsController)

import FichierLivreController from "./fichier_livre_controller"
application.register("fichier-livre", FichierLivreController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import CampaignDestinationController from "./campaign_destination_controller"
application.register("campaign-destination", CampaignDestinationController)

import CampaignPreviewController from "./campaign_preview_controller"
application.register("campaign-preview", CampaignPreviewController)

import CfUploadController from "./cf_upload_controller"
application.register("cf-upload", CfUploadController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ClickTrackingController from "./click_tracking_controller"
application.register("click-tracking", ClickTrackingController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CmComposerController from "./cm_composer_controller"
application.register("cm-composer", CmComposerController)

import CmdKController from "./cmd_k_controller"
application.register("cmd-k", CmdKController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CommentUploadController from "./comment_upload_controller"
application.register("comment-upload", CommentUploadController)

import ConsultAvailabilityController from "./consult_availability_controller"
application.register("consult-availability", ConsultAvailabilityController)

import ConsultFormatController from "./consult_format_controller"
application.register("consult-format", ConsultFormatController)

import ConsultIntentController from "./consult_intent_controller"
application.register("consult-intent", ConsultIntentController)



import ConsultSlotPickerController from "./consult_slot_picker_controller"
application.register("consult-slot-picker", ConsultSlotPickerController)

import ConsultSlotsController from "./consult_slots_controller"
import ConsultGroupeController from "./consult_groupe_controller"
application.register("consult-groupe", ConsultGroupeController)
application.register("consult-slots", ConsultSlotsController)

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import CourseBuilderController from "./course_builder_controller"
application.register("course-builder", CourseBuilderController)

import DatetimePickerController from "./datetime_picker_controller"
application.register("datetime-picker", DatetimePickerController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import DocumentUploadController from "./document_upload_controller"
application.register("document-upload", DocumentUploadController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ErrorScrollerController from "./error_scroller_controller"
application.register("error-scroller", ErrorScrollerController)

import FeedComposerController from "./feed_composer_controller"
application.register("feed-composer", FeedComposerController)

import FeedLikeController from "./feed_like_controller"
application.register("feed-like", FeedLikeController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FloatingToolbarController from "./floating_toolbar_controller"
application.register("floating-toolbar", FloatingToolbarController)

import FontSearchController from "./font_search_controller"
application.register("font-search", FontSearchController)

import FormBuilderController from "./form_builder_controller"
application.register("form-builder", FormBuilderController)

import FunnelBuilderController from "./funnel_builder_controller"
application.register("funnel-builder", FunnelBuilderController)

import FunnelCheckoutController from "./funnel_checkout_controller"
application.register("funnel-checkout", FunnelCheckoutController)

import FunnelStepFormController from "./funnel_step_form_controller"
application.register("funnel-step-form", FunnelStepFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageSizingController from "./image_sizing_controller"
application.register("image-sizing", ImageSizingController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LandingAnimationsController from "./landing_animations_controller"
application.register("landing-animations", LandingAnimationsController)

import LeadFunnelController from "./lead_funnel_controller"
application.register("lead-funnel", LeadFunnelController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import LiveEventCountdownController from "./live_event_countdown_controller"
application.register("live-event-countdown", LiveEventCountdownController)

import LiveRoomController from "./live_room_controller"
application.register("live-room", LiveRoomController)

import MentionAutocompleteController from "./mention_autocomplete_controller"
application.register("mention-autocomplete", MentionAutocompleteController)

import MessageStyleController from "./message_style_controller"
application.register("message-style", MessageStyleController)

import MobileSidebarController from "./mobile_sidebar_controller"
application.register("mobile-sidebar", MobileSidebarController)

import ModalFrameController from "./modal_frame_controller"
application.register("modal-frame", ModalFrameController)

import MultistepFormController from "./multistep_form_controller"
application.register("multistep-form", MultistepFormController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import PageEditorController from "./page_editor_controller"
application.register("page-editor", PageEditorController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PaymentMethodToggleController from "./payment_method_toggle_controller"
application.register("payment-method-toggle", PaymentMethodToggleController)

import PlatformTabsController from "./platform_tabs_controller"
application.register("platform-tabs", PlatformTabsController)

import PollFormController from "./poll_form_controller"
application.register("poll-form", PollFormController)

import PollTemplateFormController from "./poll_template_form_controller"
application.register("poll-template-form", PollTemplateFormController)

import PreflightController from "./preflight_controller"
application.register("preflight", PreflightController)

import PricingController from "./pricing_controller"
application.register("pricing", PricingController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import PrixDetailController from "./prix_detail_controller"
application.register("prix-detail", PrixDetailController)

import ProductFormController from "./product_form_controller"
application.register("product-form", ProductFormController)

import PromoCodeController from "./promo_code_controller"
application.register("promo-code", PromoCodeController)

import PromoPeriodController from "./promo_period_controller"
application.register("promo-period", PromoPeriodController)

import PromoTargetsController from "./promo_targets_controller"
application.register("promo-targets", PromoTargetsController)

import ProviderKindController from "./provider_kind_controller"
application.register("provider-kind", ProviderKindController)

import RateLiveController from "./rate_live_controller"
application.register("rate-live", RateLiveController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import RealtimeKpisController from "./realtime_kpis_controller"
application.register("realtime-kpis", RealtimeKpisController)

import ReplayChaptersController from "./replay_chapters_controller"
application.register("replay-chapters", ReplayChaptersController)

import ReplyTemplatesController from "./reply_templates_controller"
application.register("reply-templates", ReplyTemplatesController)

import ResendTimerController from "./resend_timer_controller"
application.register("resend-timer", ResendTimerController)

import RowBlockController from "./row_block_controller"
application.register("row-block", RowBlockController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SentinelTrackingController from "./sentinel_tracking_controller"
application.register("sentinel-tracking", SentinelTrackingController)

import SidebarDropdownController from "./sidebar_dropdown_controller"
application.register("sidebar-dropdown", SidebarDropdownController)

import SlugCheckController from "./slug_check_controller"
application.register("slug-check", SlugCheckController)

import SlugCheckerController from "./slug_checker_controller"
application.register("slug-checker", SlugCheckerController)

import SlugSyncController from "./slug_sync_controller"
application.register("slug-sync", SlugSyncController)

import SubmitLockController from "./submit_lock_controller"
application.register("submit-lock", SubmitLockController)

import SubscriptionCheckoutController from "./subscription_checkout_controller"
application.register("subscription-checkout", SubscriptionCheckoutController)

import SubscriptionPaymentController from "./subscription_payment_controller"
application.register("subscription-payment", SubscriptionPaymentController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TvaReglageController from "./tva_reglage_controller"
application.register("tva-reglage", TvaReglageController)

import TypePickerController from "./type_picker_controller"
application.register("type-picker", TypePickerController)

import TypewriterController from "./typewriter_controller"
application.register("typewriter", TypewriterController)

import UtmBuilderController from "./utm_builder_controller"
application.register("utm-builder", UtmBuilderController)

import VideoFacadeController from "./video_facade_controller"
application.register("video-facade", VideoFacadeController)

import VideoLoaderController from "./video_loader_controller"
application.register("video-loader", VideoLoaderController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import VideoProtectionController from "./video_protection_controller"
application.register("video-protection", VideoProtectionController)

import VideoTrackerController from "./video_tracker_controller"
application.register("video-tracker", VideoTrackerController)

import VideoUploadController from "./video_upload_controller"
application.register("video-upload", VideoUploadController)

import VisibilityToggleController from "./visibility_toggle_controller"
application.register("visibility-toggle", VisibilityToggleController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)

import WorkspacePaymentSettingsController from "./workspace_payment_settings_controller"
application.register("workspace-payment-settings", WorkspacePaymentSettingsController)

import WorkspaceSwitcherController from "./workspace_switcher_controller"
application.register("workspace-switcher", WorkspaceSwitcherController)

import MetaEventController from "./meta_event_controller"
application.register("meta-event", MetaEventController)
